import { ApiServiceBase } from './ApiServiceBase'
import type { LocationQueryValue } from 'vue-router'

type Query = {
  filter?: string | LocationQueryValue[]
}

export default class extends ApiServiceBase {
  async index(query: Query): Promise<any> {
    return useAsyncData('skipped-approaches', () => this.call('/spa/approaches/skipped', { query: query }))
  }
}
